/**
 * Catálogo Oleum — toolbar Filtrar + barra lateral colapsable + etiquetas en español.
 */
(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  var SORT_LABELS = {
    manual: 'Destacados',
    'best-selling': 'Más vendidos',
    relevance: 'Más relevantes',
    'most-relevant': 'Más relevantes',
    'title-ascending': 'Nombre, A-Z',
    'title-descending': 'Nombre, Z-A',
    'price-ascending': 'Precio: menor a mayor',
    'price-descending': 'Precio: mayor a menor',
    'created-ascending': 'Fecha: antigua a reciente',
    'created-descending': 'Fecha: reciente a antigua',
  };

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  var DRAWER_TRANSITION_MS = 320;

  function getCategorySidebar(section) {
    if (!section) return null;
    return section.querySelector('.oleum-collection-category-sidebar, [data-oleum-search-sidebar]');
  }

  function revealFilterSidebar(sidebar, open) {
    if (!sidebar) return;
    if (open) {
      sidebar.removeAttribute('hidden');
      sidebar.setAttribute('aria-hidden', 'false');
    } else if (sidebar.hasAttribute('data-oleum-search-sidebar')) {
      sidebar.setAttribute('aria-hidden', 'true');
    }
  }

  function setFiltersOpen(section, open) {
    var btn = section.querySelector('[data-oleum-filters-toggle]');
    if (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    var backdrop = section.querySelector('[data-oleum-filters-backdrop]');
    var sidebar = getCategorySidebar(section);
    revealFilterSidebar(sidebar, open);

    if (isDesktop()) {
      section.classList.toggle('oleum-filters-open', open);
      if (backdrop) {
        backdrop.hidden = true;
        backdrop.classList.remove('is-visible');
      }
      document.body.classList.remove('oleum-filters-drawer-open');
      return;
    }

    var isOpen = section.classList.contains('oleum-filters-open');
    if (open === isOpen) return;

    if (open) {
      section.classList.add('oleum-filters-open');
      document.body.classList.add('oleum-filters-drawer-open');
      if (sidebar) sidebar.setAttribute('aria-hidden', 'false');
      if (backdrop) {
        backdrop.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            backdrop.classList.add('is-visible');
          });
        });
      }
      return;
    }

    section.classList.remove('oleum-filters-open');
    document.body.classList.remove('oleum-filters-drawer-open');
    if (sidebar) sidebar.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-visible');

    function hideBackdrop() {
      if (backdrop && !section.classList.contains('oleum-filters-open')) {
        backdrop.hidden = true;
      }
    }

    if (sidebar) {
      function onDrawerClosed(event) {
        if (event.target !== sidebar || event.propertyName !== 'transform') return;
        sidebar.removeEventListener('transitionend', onDrawerClosed);
        hideBackdrop();
      }
      sidebar.addEventListener('transitionend', onDrawerClosed);
      window.setTimeout(hideBackdrop, DRAWER_TRANSITION_MS + 80);
    } else {
      window.setTimeout(hideBackdrop, DRAWER_TRANSITION_MS);
    }
  }

  function setupMobileDrawer(section) {
    if (section.getAttribute('data-oleum-drawer-init') === '1') return;
    section.setAttribute('data-oleum-drawer-init', '1');

    var sidebar = getCategorySidebar(section);
    if (!sidebar) return;

    var backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'oleum-filters-backdrop';
    backdrop.setAttribute('data-oleum-filters-backdrop', '');
    backdrop.setAttribute('aria-label', 'Cerrar filtros');
    backdrop.hidden = true;
    section.insertBefore(backdrop, section.firstChild);

    backdrop.addEventListener('click', function () {
      setFiltersOpen(section, false);
    });

    var nav = sidebar.querySelector('.oleum-collection-category-nav');
    var heading = nav && nav.querySelector('.oleum-collection-category-nav__heading');
    if (heading && !sidebar.querySelector('[data-oleum-filters-close]')) {
      var topBar = document.createElement('div');
      topBar.className = 'oleum-collection-category-sidebar__top';
      heading.parentNode.insertBefore(topBar, heading);
      topBar.appendChild(heading);

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'oleum-filters-close button-unstyled';
      closeBtn.setAttribute('data-oleum-filters-close', '');
      closeBtn.setAttribute('aria-label', 'Cerrar filtros');
      closeBtn.innerHTML =
        '<span class="svg-wrapper" aria-hidden="true">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round">' +
        '<path d="M5 5l10 10M15 5L5 15"/>' +
        '</svg></span>';
      sidebar.appendChild(closeBtn);

      closeBtn.addEventListener('click', function () {
        setFiltersOpen(section, false);
      });
    }

    sidebar.addEventListener('click', function (event) {
      if (!isDesktop() && section.classList.contains('oleum-filters-open')) {
        var link = event.target.closest('.oleum-collection-category-nav__link');
        if (link) {
          setFiltersOpen(section, false);
        }
      }
    });

    if (!isDesktop()) {
      sidebar.setAttribute('aria-hidden', 'true');
    }
  }

  function buildFilterButton(label, gaLabel) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oleum-catalog-toolbar__filter-btn button-unstyled';
    btn.setAttribute('data-oleum-filters-toggle', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('data-eventoclick', (gaLabel || 'coleccion') + '_filtrar_toggle');
    btn.setAttribute('data-ga-cta-type', 'filtrar');
    btn.innerHTML =
      '<span class="oleum-catalog-toolbar__filter-icon svg-wrapper" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 5h14M6 10h8M9 15h2"/></svg>' +
      '</span>' +
      '<span class="oleum-catalog-toolbar__filter-text">' +
      escapeHtml(label || 'Filtrar') +
      '</span>';
    return btn;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function setCatalogLoading(section, loading) {
    section.classList.toggle('oleum-catalog-is-loading', loading);
    var gridWrap =
      section.querySelector('.main-collection-grid') || section.querySelector('.product-grid-container');
    if (gridWrap) {
      gridWrap.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  }

  function bindCatalogLoading(section) {
    if (section.getAttribute('data-oleum-loading-bound') === '1') return;
    section.setAttribute('data-oleum-loading-bound', '1');

    document.addEventListener(
      'filter:update',
      function (event) {
        if (!section.contains(event.target)) return;
        setCatalogLoading(section, true);
      },
      true
    );

    section.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (
          (target instanceof HTMLInputElement || target instanceof HTMLSelectElement) &&
          target.name === 'sort_by' &&
          section.contains(target)
        ) {
          setCatalogLoading(section, true);
        }
      },
      true
    );

    var grid = section.querySelector('[ref="grid"]') || section.querySelector('.product-grid');
    if (!grid) return;

    var clearLoading = debounce(function () {
      setCatalogLoading(section, false);
    }, 120);

    var gridObserver = new MutationObserver(clearLoading);
    gridObserver.observe(grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-last-page'],
    });

    document.addEventListener(
      'filter:update',
      function (event) {
        if (!section.contains(event.target)) return;
        window.setTimeout(function () {
          if (section.classList.contains('oleum-catalog-is-loading')) {
            setCatalogLoading(section, false);
          }
        }, 10000);
      },
      true
    );
  }

  function localizeSpanishToolbar(section) {
    section.querySelectorAll('.facets__label').forEach(function (el) {
      if (/^sort$/i.test(el.textContent.trim())) {
        el.textContent = 'Ordenar';
      }
    });

    section.querySelectorAll('.sorting-filter__input[name="sort_by"]').forEach(function (input) {
      var label = SORT_LABELS[input.value];
      if (!label) return;
      input.dataset.optionName = label;
      var textEl = input.parentElement && input.parentElement.querySelector('.sorting-filter__label');
      if (textEl) textEl.textContent = label;
    });

    section.querySelectorAll('.sorting-filter__select option').forEach(function (opt) {
      var label = SORT_LABELS[opt.value];
      if (label) opt.textContent = label;
    });

    var countEl = section.querySelector('.products-count-wrapper [role="status"]');
    if (countEl) {
      countEl.textContent = countEl.textContent
        .replace(/\bMore than ([\d,]+) items?\b/gi, 'Más de $1 productos')
        .replace(/\b([\d,]+)\s+items\b/gi, '$1 productos')
        .replace(/\b([\d,]+)\s+item\b/gi, '$1 producto');
    }
  }

  function setupToolbar(section) {
    var bar = section.querySelector('.facets--horizontal.facets-controls-wrapper');
    if (!bar || bar.getAttribute('data-oleum-toolbar-init') === '1') return;
    bar.setAttribute('data-oleum-toolbar-init', '1');
    bar.classList.add('oleum-catalog-toolbar');

    var title = bar.querySelector('.facets--filters-title');
    if (title) title.hidden = true;

    var label = section.getAttribute('data-oleum-filter-label') || 'Filtrar';
    var gaLabel = section.getAttribute('data-ga-section-label') || 'coleccion';
    var filterBtn = buildFilterButton(label, gaLabel);

    var actions = bar.querySelector('.oleum-catalog-toolbar__actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'oleum-catalog-toolbar__actions';
      bar.appendChild(actions);
    }

    var sorting = bar.querySelector('.sorting-filter');
    var density = bar.querySelector('.column-options-wrapper');

    actions.insertBefore(filterBtn, actions.firstChild);
    if (sorting && sorting.parentElement !== actions) actions.appendChild(sorting);
    if (density && density.parentElement !== actions) actions.appendChild(density);

    filterBtn.addEventListener('click', function () {
      if (isDesktop()) {
        var open = !section.classList.contains('oleum-filters-open');
        setFiltersOpen(section, open);
        return;
      }
      setFiltersOpen(section, !section.classList.contains('oleum-filters-open'));
    });

    localizeSpanishToolbar(section);
  }

  var escapeBound = false;

  function bindGlobalDrawerHandlers() {
    if (escapeBound) return;
    escapeBound = true;

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document
        .querySelectorAll('[data-oleum-collapsible-filters="1"].oleum-filters-open')
        .forEach(function (el) {
          if (!isDesktop()) setFiltersOpen(el, false);
        });
    });

    DESKTOP_MQ.addEventListener('change', function () {
      document.querySelectorAll('[data-oleum-collapsible-filters="1"].oleum-filters-open').forEach(function (el) {
        var backdrop = el.querySelector('[data-oleum-filters-backdrop]');
        var sidebar = getCategorySidebar(el);
        if (!isDesktop()) {
          setFiltersOpen(el, false);
        } else {
          if (backdrop) {
            backdrop.hidden = true;
            backdrop.classList.remove('is-visible');
          }
          if (sidebar) sidebar.setAttribute('aria-hidden', 'false');
          document.body.classList.remove('oleum-filters-drawer-open');
        }
      });
    });
  }
  function initSection(section) {
    if (!section || section.getAttribute('data-oleum-collapsible-filters') !== '1') return;

    bindGlobalDrawerHandlers();
    setupMobileDrawer(section);
    setupToolbar(section);
    localizeSpanishToolbar(section);

    if (!section.getAttribute('data-oleum-catalog-init')) {
      section.setAttribute('data-oleum-catalog-init', '1');

      if (!isDesktop()) {
        section.classList.remove('oleum-filters-open');
        document.body.classList.remove('oleum-filters-drawer-open');
      }

      var syncToolbar = debounce(function () {
        localizeSpanishToolbar(section);
        if (!section.querySelector('[data-oleum-toolbar-init="1"]')) {
          setupToolbar(section);
        }
      }, 80);

      var observer = new MutationObserver(syncToolbar);
      observer.observe(section, { childList: true, subtree: true });
    }

    bindCatalogLoading(section);
  }

  function init() {
    document.querySelectorAll('[data-oleum-collapsible-filters="1"]').forEach(initSection);
    document.querySelectorAll('[data-oleum-search-sidebar]').forEach(function (sidebar) {
      sidebar.removeAttribute('hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-oleum-collapsible-filters="1"]');
    if (section) initSection(section);
  });
})();
